import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Herramientas', href: '#beneficios' },
    { label: 'Bonos', href: '#bonos' },
    { label: 'Precio', href: '#precio' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md border-b border-[#8b5cf6]/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/dc8c408a-3915-4d38-a25e-c286d31ca428.png"
            alt="Super Pack Logo"
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* Desktop Links */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="text-gray-300 hover:text-[#8b5cf6] transition-colors duration-200 text-sm font-medium cursor-pointer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA Desktop */}
        <a
          href="https://wa.link/3odpj7"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-gradient-to-r from-[#8b5cf6] to-[#ec4899] text-white font-bold text-sm px-5 py-2.5 rounded-full whitespace-nowrap hover:scale-105 transition-transform duration-200 cursor-pointer"
        >
          <span>⚡</span> Comprar Ahora
        </a>

        {/* Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 text-gray-300 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0a]/98 border-t border-[#8b5cf6]/20 px-4 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-gray-300 hover:text-[#8b5cf6] text-base font-medium py-2 cursor-pointer transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://wa.link/3odpj7"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 bg-gradient-to-r from-[#8b5cf6] to-[#ec4899] text-white font-bold text-sm px-5 py-3 rounded-full whitespace-nowrap cursor-pointer"
          >
            ⚡ Comprar Ahora
          </a>
        </div>
      )}
    </nav>
  );
}
